import script from "./UpgradeRows.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeRows.vue?vue&type=script&setup=true&lang=js"

import "./UpgradeRows.vue?vue&type=style&index=0&id=1c3e2d2a&lang=scss"

const __exports__ = script;

export default __exports__